import ResultsHeader from './ResultsHeader';

export default ResultsHeader;
